import { cn } from "@/lib/utils";

const Container = ({ className, children }) => (
  <div className={cn("mx-auto max-w-7xl px-4 md:px-8", className)}>
    {children}
  </div>
);

export { Container };
